import { OCPSDataStoreType } from './schema/OCPSDataStoreType';

/**
 * OCPSDataStore is an object based store as the UI doesn't react to the
 * changes done in this store.
 */
export const OCPSDataStore: OCPSDataStoreType = {
    policies: {},
    policyExpirationDate: null,
};
